import { useState, useEffect } from 'react'
import { GameState } from '../store/types'
import { apiRegionList, apiCharMove } from '../server/ServiceCall'

interface Region {
  regionId: string; regionName: string; minPower: number; moveCost: number; description: string
}

interface Props { gs: GameState; token: string; onRefresh: () => void }

export default function TabMove({ gs, token, onRefresh }: Props) {
  const [regions, setRegions] = useState<Region[]>([])
  const [loading, setLoading] = useState(false)
  const [busy,    setBusy]    = useState(false)
  const [msg,     setMsg]     = useState('')
  const [msgOk,   setMsgOk]   = useState(false)

  function showMsg(m: string, ok = false) { setMsg(m); setMsgOk(ok); setTimeout(() => setMsg(''), 3000) }

  useEffect(() => {
    setLoading(true)
    apiRegionList(token)
      .then(res => {
        if (res.resultCode === '00') {
          const raw = JSON.parse(res.resultData || '[]') as any[]
          setRegions(raw.map(r => ({
            regionId:    String(r.REGION_ID),
            regionName:  String(r.REGION_NAME),
            minPower:    Number(r.MIN_POWER) || 0,
            moveCost:    Number(r.MOVE_COST) || 0,
            description: String(r.DESCRIPTION ?? ''),
          })))
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [token])

  async function doMove(regionId: string) {
    setBusy(true)
    try {
      const res = await apiCharMove(token, regionId)
      showMsg(res.resultMessage, res.resultCode === '00')
      if (res.resultCode === '00') onRefresh()
    } catch { showMsg('서버 오류') }
    finally { setBusy(false) }
  }

  const current   = gs.char.currentRegion
  const gold      = gs.char.gold
  const hasAction = !!gs.char.activeAction

  return (
    <div className="tab-action">
      {msg && <div className={`inven-msg${msgOk ? ' ok' : ''}`}>{msg}</div>}

      {hasAction && (
        <div style={{ background:'#3a1a0a', border:'1px solid #a05020', borderRadius:4,
          padding:'8px 12px', marginBottom:8, fontSize:12, color:'#e0a060' }}>
          훈련/사냥 중에는 이동할 수 없습니다.
        </div>
      )}

      <div className="card-title" style={{ marginBottom:8 }}>지역 이동</div>

      {loading ? (
        <div style={{ color:'#605040', textAlign:'center', padding:'30px 0' }}>불러오는 중...</div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
          {regions.map(r => {
            const isCurrent = r.regionId === current
            const canAfford = gold >= r.moveCost

            return (
              <div key={r.regionId} style={{
                background: isCurrent ? '#1a2a1a' : '#1a1208',
                border: `1px solid ${isCurrent ? '#4a8a4a' : '#4a3a20'}`,
                borderRadius: 4, padding: '10px 12px',
              }}>
                <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                  <span style={{ fontWeight:'bold', fontSize:14,
                    color: isCurrent ? '#80c080' : '#c8b890' }}>
                    {r.regionName}
                  </span>
                  {isCurrent && (
                    <span style={{ fontSize:10, color:'#60a060', border:'1px solid #406040',
                      padding:'1px 4px', borderRadius:2 }}>현재 위치</span>
                  )}
                </div>
                <div style={{ fontSize:11, color:'#806050', marginBottom:6 }}>{r.description}</div>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                  <span style={{ fontSize:11, color: !canAfford && !isCurrent ? '#c05030' : '#a09060' }}>
                    {r.moveCost > 0 ? `이동비 ${r.moveCost.toLocaleString()}전` : '이동비 무료'}
                  </span>
                  {!isCurrent && (
                    <button
                      className="action-btn equip"
                      style={{ padding:'4px 12px', fontSize:12 }}
                      disabled={busy || hasAction || !canAfford}
                      onClick={() => doMove(r.regionId)}
                    >
                      이동
                    </button>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
